(function () {

  // ── Caches de fetch ─────────────────────────────────────────────────────────

  const cache = {};

  function fetchProductData(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(Shopify.routes.root + 'products/' + handle + '?view=dt-json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  const cardCache = {};

  function fetchCardHtml(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = fetch(Shopify.routes.root + 'products/' + handle + '?view=dt-card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }
    return cardCache[handle];
  }

  // ── Variante seleccionada ───────────────────────────────────────────────────

  function initVariantSelector(card) {
    var items = card.querySelectorAll('.dt-product-card__variants-overlay .dt-selector__item');
    if (!items.length) return;

    var firstItem = card.querySelector('.dt-product-card__variants-overlay .dt-selector__item:not(.is-disabled)');
    if (firstItem) selectVariant(card, firstItem.querySelector('.dt-selector__swatch'));

    items.forEach(function (item) {
      var btn = item.querySelector('.dt-selector__swatch');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        selectVariant(card, btn);
      });
    });
  }

  function selectVariant(card, btn) {
    var swatchRoot = card.querySelector('.dt-product-card__variants-overlay')
      || document.querySelector('.dt-product-card__variants-overlay.dt-sheet-active');
    if (swatchRoot) {
      swatchRoot.querySelectorAll('.dt-selector__swatch').forEach(function (s) {
        s.closest('.dt-selector__item').classList.remove('dt-selector__item--current');
      });
    }
    btn.closest('.dt-selector__item').classList.add('dt-selector__item--current');
    var idInput = card.querySelector('.dt-card-atc-id');
    if (idInput) idInput.value = btn.dataset.variantId;
  }

  // ── Selector de material ────────────────────────────────────────────────────

  function processCard(ul) {
    if (ul.dataset.dtSelectorMaterialDone) return;
    ul.dataset.dtSelectorMaterialDone = '1';

    var currentMaterial = {
      label: ul.dataset.materialLabel,
      image: ul.dataset.materialImage,
      order: parseInt(ul.dataset.materialOrder, 10) || 999
    };
    var currentCirconita = ul.dataset.circonita;
    var currentGema      = ul.dataset.gema;
    var currentHandle    = ul.dataset.handle;
    var relHandles = ul.dataset.rels ? ul.dataset.rels.split(',').filter(Boolean) : [];

    if (!relHandles.length) return;

    Promise.all(relHandles.map(fetchProductData)).then(function (results) {
      var seen = {};
      seen[currentMaterial.label] = true;
      var entries = [{ material: currentMaterial, handle: currentHandle, isCurrent: true, available: true }];

      results.forEach(function (data) {
        if (!data || !data.material || !data.material.label) return;
        if ((data.circonita || '') !== currentCirconita || (data.gema || '') !== currentGema) return;
        if (seen[data.material.label]) return;
        seen[data.material.label] = true;
        entries.push({ material: data.material, handle: data.handle, isCurrent: false, available: data.available !== false });
      });

      if (entries.length <= 1) return;

      // Orden visual: campo Order del metaobject de material (ya no hay lista ES/EN/FR hardcodeada, TASK-0039)
      entries.sort(function (a, b) {
        return (a.material.order || 999) - (b.material.order || 999);
      });

      ul.innerHTML = '';
      entries.forEach(function (entry) {
        var li = document.createElement('li');
        li.className = 'dt-selector__item' + (entry.isCurrent ? ' dt-selector__item--current' : '') + (!entry.available ? ' is-disabled' : '');
        var a = document.createElement('a');
        a.href = Shopify.routes.root + 'products/' + entry.handle;
        a.className = 'dt-selector__swatch';
        a.setAttribute('aria-label', entry.material.label);
        a.setAttribute('data-value', entry.material.label);
        if (entry.material.image) {
          a.style.background = "center / contain no-repeat url('" + entry.material.image + "')";
        }
        a.dataset.handle = entry.handle;
        if (entry.isCurrent) {
          a.setAttribute('aria-current', 'page');
        } else {
          a.addEventListener('click', function (e) {
            e.preventDefault();
            swapCard(ul, entry.handle);
          });
        }
        li.appendChild(a);
        ul.appendChild(li);
      });
    });
  }

  // ── Drag-to-scroll en slider de imágenes (desktop) ─────────────────────────

  function initSliderDrag(card) {
    if (window.matchMedia('(min-width: 1000px)').matches) return;
    var slider = card.querySelector('.dt-card-slider');
    if (!slider || slider.dataset.dtSliderDrag) return;
    slider.dataset.dtSliderDrag = '1';

    var isDragging = false;
    var startX = 0;
    var scrollLeft = 0;
    var hasDragged = false;

    slider.addEventListener('mousedown', function (e) {
      isDragging = true;
      hasDragged = false;
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) hasDragged = true;
      slider.scrollLeft = scrollLeft - dx;
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';
    });

    slider.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        hasDragged = false;
      }
    });

    slider.style.cursor = 'grab';
  }

  // ── Flujo ATC en móvil (dos toques) ────────────────────────────────────────

  function initMobileAtcFlow(card) {
    var overlay = card.querySelector('.dt-product-card__variants-overlay');
    if (!overlay) return;

    var openBtn   = card.querySelector('.product-card__quick-add-button');
    if (!openBtn || openBtn.dataset.dtMobileAtcDone) return;
    openBtn.dataset.dtMobileAtcDone = '1';

    var backdrop      = overlay.querySelector('.dt-sheet-backdrop');
    var panel         = overlay.querySelector('.dt-sheet-panel');
    var atcBtn        = panel ? panel.querySelector('.dt-sheet-atc-btn') : null;
    var submitBtn     = card.querySelector('.dt-card-atc-submit');
    var overlayParent = overlay.parentNode;

    function closeSheet(e) {
      if (e) e.stopPropagation();
      overlay.classList.remove('dt-sheet-active');
      if (overlay.parentNode === document.body) overlayParent.appendChild(overlay);
      card.classList.remove('dt-mobile-overlay-open');
      document.body.classList.remove('dt-sheet-open');
      var lookTrigger = document.querySelector('[aria-controls="look-drawer"]');
      if (lookTrigger && lookTrigger.getAttribute('aria-expanded') === 'true') {
        lookTrigger.click();
      }
    }

    openBtn.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 999px)').matches) {
        document.body.appendChild(overlay);
        overlay.classList.add('dt-sheet-active');
        card.classList.add('dt-mobile-overlay-open');
        document.body.classList.add('dt-sheet-open');
      } else if (submitBtn) {
        submitBtn.click();
      }
    });

    if (backdrop) backdrop.addEventListener('click', closeSheet);

    if (panel) {
      var touchStartY = 0;
      panel.addEventListener('touchstart', function (e) {
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      panel.addEventListener('touchend', function (e) {
        if (e.changedTouches[0].clientY - touchStartY > 60) closeSheet();
      }, { passive: true });
    }

    if (atcBtn && submitBtn) {
      atcBtn.addEventListener('click', function () {
        submitBtn.click();
        setTimeout(closeSheet, 300);
      });
    }
  }

  // ── Swap de card al cambiar material ───────────────────────────────────────

  function swapCard(ul, handle) {
    var productCard = ul.closest('product-card');
    if (!productCard) return;

    fetchCardHtml(handle).then(function (html) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      var newCard = tmp.querySelector('product-card');
      if (!newCard) return;

      productCard.replaceWith(newCard);
      processAll(newCard);
      initVariantSelector(newCard);
      initMobileAtcFlow(newCard);
      initSliderDrag(newCard);
    });
  }

  function processAll(root) {
    root.querySelectorAll('[data-dt-selector-material]').forEach(processCard);
  }

  // ── DT Slideshow: carrusel propio (hereda de SlideshowCarousel) ─────────────
  // TASK-0019: dt-slideshow-carousel hereda todo el comportamiento de
  // SlideshowCarousel (autoplay, swipe, vídeo, puntos de navegación) y solo
  // sobreescribe createOnChangeAnimationControls para poder ofrecer, además del
  // fundido original, una transición de deslizamiento horizontal cuando el
  // atributo transition-style="slide" está presente (ver dt-slideshow.liquid).
  //
  // El ciclo base (EffectCarousel.select(), en theme.js) es secuencial: primero
  // termina de salir la slide actual, luego se intercambian las clases
  // is-selected, luego entra la nueva. leaveControls/enterControls deben
  // devolver un objeto con .finished (promise) y .finish() (usado en modo
  // instantáneo), igual que el que ya usa SlideshowCarousel — por eso se
  // envuelve cada Animation nativa (Element.animate) en ese mismo contrato.

  function animateSlideTransform(element, fromX, toX, duration, easing) {
    var animation = element.animate(
      [{ transform: 'translateX(' + fromX + ')' }, { transform: 'translateX(' + toX + ')' }],
      { duration: duration, easing: easing, fill: 'both' }
    );
    return {
      finished: animation.finished.then(function () {
        animation.commitStyles();
        animation.cancel();
      }),
      finish: function () { animation.finish(); }
    };
  }

  (function initDtSlideshowCarousel() {
    if (window.customElements.get('dt-slideshow-carousel')) return;

    import('theme').then(function (themeModule) {
      var SlideshowCarousel = themeModule.SlideshowCarousel;

      class DtSlideshowCarousel extends SlideshowCarousel {
        createOnChangeAnimationControls(fromSlide, toSlide, options) {
          var direction = options && options.direction;

          if (this.getAttribute('transition-style') !== 'slide') {
            return super.createOnChangeAnimationControls(fromSlide, toSlide, options);
          }

          var duration = 350;
          var easing = 'cubic-bezier(0.65, 0, 0.35, 1)';
          var leaveTo = direction === 'previous' ? '100%' : '-100%';
          var enterFrom = direction === 'previous' ? '-100%' : '100%';

          return {
            leaveControls: function () {
              return animateSlideTransform(fromSlide, '0%', leaveTo, duration, easing);
            },
            enterControls: function () {
              return animateSlideTransform(toSlide, enterFrom, '0%', duration, easing);
            }
          };
        }
      }

      window.customElements.define('dt-slideshow-carousel', DtSlideshowCarousel);
    });
  })();

  // ── Inicialización ──────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {

    // Product cards
    processAll(document);
    document.querySelectorAll('product-card').forEach(function (card) {
      initVariantSelector(card);
      initMobileAtcFlow(card);
      initSliderDrag(card);
    });

    // Ajaxinate: re-inicializar cards nuevas al hacer scroll infinito
    var productList = document.querySelector('.product-list-ajaxinate');
    if (productList) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('product-card')) {
              node.style.opacity = '1';
              node.style.transform = 'translateY(0)';
            }
            if (node.matches('[data-dt-selector-material]')) {
              processCard(node);
            } else {
              processAll(node);
            }
            if (node.matches('product-card')) {
              initVariantSelector(node);
              initMobileAtcFlow(node);
              initSliderDrag(node);
            } else if (node.querySelector) {
              node.querySelectorAll('product-card').forEach(function (card) {
                initVariantSelector(card);
                initMobileAtcFlow(card);
                initSliderDrag(card);
              });
            }
          });
        });
      }).observe(productList, { childList: true, subtree: true });
    }

    // Header: ocultar al hacer scroll en páginas de colección (solo escritorio — en móvil se queda sticky, TASK-0063)
    if (document.body.classList.contains('template-collection')) {
      var lastScrollY = window.scrollY;
      var header = document.querySelector('x-header');
      var isMobileHeaderQuery = window.matchMedia(window.themeVariables.mediaQueries['sm-max']);
      window.addEventListener('scroll', function () {
        if (!header || isMobileHeaderQuery.matches) return;
        if (window.scrollY > lastScrollY && window.scrollY > 80) {
          header.classList.add('dt-header--hidden');
          document.body.classList.add('dt-header-hidden');
        } else {
          header.classList.remove('dt-header--hidden');
          document.body.classList.remove('dt-header-hidden');
        }
        lastScrollY = window.scrollY;
      }, { passive: true });
    }

  });

})();